// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	AddIdButton: 'add-id-button',
	CancelButton: 'cancel-button',
	SaveButton: 'save-button',
	PrimaryContactCheckbox: 'primary-contact-checkbox',
	DateOfBirthDatePicker: 'date-of-birth-date-picker',
	TitleDropdown: 'title-dropdown',
	FirstName: 'first-name',
	MiddleNames: 'middle-names',
	LastName: 'last-name',
	CellPhone: 'cell-phone',
	Email: 'email',
	RepresentationTypeRadioGroup: 'representation-type-radio-group',
	GenderRadioGroup: 'gender-radio-group',
	//	MyHookName: 'myHookIdentifier',
} as const;
/*
NOTE: The above hooks have been auto generated, all naming is a best guess approach.
Please review them, edit where necessary and delete this comment to indicate that the names are correct.
*/
